import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=45727c5b&scoped=true"
import script from "./SecondStep.vue?vue&type=script&lang=js"
export * from "./SecondStep.vue?vue&type=script&lang=js"
import style0 from "./SecondStep.vue?vue&type=style&index=0&id=45727c5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45727c5b",
  null
  
)

export default component.exports